import { Card } from "antd";
import * as COMMONS from "common/common";
import moment from "moment";
import { cn } from "libs/classnames";
import { size } from "lodash";

const Occurrence = (props) => {
	const { publicSettings, occurrence, isDetail, category } = props;
	const reservationCount = size(occurrence?.registrations);

	const getStyle = (value) => {
		const isFull = value >= occurrence?.maxAttendee;
		const isZero = value === 0;

		if (isFull) {
			return COMMONS.RESERVATION_STYLE(publicSettings);
		}

		if (isZero) {
			return COMMONS.ZERO_STYLE(publicSettings);
		}

		return COMMONS.OCCURRENCE_TIME_STYLE(publicSettings);
	};

	return isDetail ? (
		<Card
			hoverable={false}
			bordered={false}
			styles={{ body: { padding: 0 } }}
			className={cn({
				grayscale: !occurrence?.isDisplayed,
			})}
		>
			<div
				className="flex flex-col border rounded"
				style={{
					borderColor: publicSettings?.PRIMARY_COLOR,
				}}
			>
				<div
					className="flex p-2 rounded-t border-b justify-center"
					style={COMMONS.OCCURRENCE_TIME_STYLE(publicSettings)}
				>
					{category?.isSettingTime ? (
						<span className="font-bold text-lg">
							{occurrence?.startDate && category?.startDate
								? `${moment(occurrence.startDate).format(
										"YYYY年M月D日　",
									)}${moment(category.startDate).format("HH:mm")} `
								: "ー：ー"}
						</span>
					) : (
						<span className="font-bold text-lg">
							{occurrence?.startAt
								? moment(occurrence.startAt).format("YYYY年M月D日　HH:mm")
								: "ー：ー"}
						</span>
					)}
				</div>
				<div className="flex flex-row">
					<div
						className="flex flex-col basis-6/12 py-2 px-2"
						style={getStyle(occurrence?.sumExpected)}
					>
						<div className="text-center text-sm m-0">予約数</div>
						<div className="text-center font-bold m-0">
							<span className="text-xl">{reservationCount || 0}</span>
							<span>/{occurrence?.maxAttendee}</span>
						</div>
					</div>

					<div
						className="flex flex-col basis-6/12 py-2 px-2"
						style={{
							...getStyle(occurrence?.sumAttended),
							borderColor:
								occurrence?.sumAttended === occurrence?.maxAttendee
									? publicSettings?.PRIMARY_LIGHT_COLOR
									: publicSettings?.PRIMARY_COLOR,
							borderLeftWidth: "1px",
							borderRightWidth: "1px",
							borderStyle: "solid",
						}}
					>
						<div className="text-center text-sm m-0">参加数</div>
						<div className="text-center font-bold m-0">
							<span className="text-xl">{occurrence?.sumAttended || 0}</span>
						</div>
					</div>

					<div
						className="flex flex-col basis-6/12 py-2 px-2"
						style={COMMONS.ZERO_STYLE(publicSettings)}
					>
						<div className="text-center text-sm m-0">キャンセル数</div>
						<div className="text-center font-bold m-0">
							<span className="text-xl">
								{occurrence?.cancels?.length || 0}
							</span>
						</div>
					</div>
				</div>
			</div>
		</Card>
	) : (
		<div
			className={`h-full ${occurrence?.isDisplayed ? "" : "grayscale"}`}
			style={{ containerType: "inline-size" }}
		>
			<style>{`
				@container (max-width: 70px) {
					.occurrence-label {
						display: none !important;
					}
					.occurrence-value {
						font-size: 0.95rem !important;
					}
					.occurrence-value-sub {
						font-size: 0.65rem !important;
					}
				}
				@container (max-width: 45px) {
					.occurrence-value {
						font-size: 0.8rem !important;
					}
					.occurrence-value-sub {
						font-size: 0.6rem !important;
					}
				}
			`}</style>
			<div className="flex h-full gap-x-[1px] [&>div]:border [&>div]:border-solid [&>div]:border-[#CCCCCC]">
				<div
					className={cn(
						"flex flex-col basis-6/12 justify-center",
						{
							"grayscale bg-[#F2F2F2]":
								!occurrence?.sumExpected && occurrence?.isDisplayed,
						},
						{
							"opacity-50": !occurrence?.isDisplayed,
						},
					)}
					style={
						occurrence?.sumExpected >= occurrence?.maxAttendee
							? COMMONS.RESERVATION_STYLE(publicSettings)
							: COMMONS.OCCURRENCE_TIME_STYLE(publicSettings)
					}
				>
					<p
						className="text-center text-xs hidden sm:block occurrence-label whitespace-nowrap"
						style={{ position: "relative", top: "12px" }}
					>
						予約数
					</p>
					<p className="text-center font-bold whitespace-nowrap">
						<span className="text-xl occurrence-value">
							{occurrence?.sumExpected || 0}
							<span className="text-xs occurrence-value-sub">
								/{occurrence?.maxAttendee || 0}
							</span>
						</span>
					</p>
				</div>
				<div
					className={cn(
						"flex flex-col basis-6/12 justify-center",
						{
							"grayscale bg-[#F2F2F2]":
								!occurrence?.sumAttended && occurrence?.isDisplayed,
						},
						{
							"opacity-50": !occurrence?.isDisplayed,
						},
					)}
					style={
						occurrence?.sumAttended >= occurrence?.maxAttendee
							? COMMONS.RESERVATION_STYLE(publicSettings)
							: COMMONS.OCCURRENCE_TIME_STYLE(publicSettings)
					}
				>
					<p
						className="text-center text-xs hidden sm:block occurrence-label whitespace-nowrap"
						style={{ position: "relative", top: "12px" }}
					>
						参加数
					</p>
					<p className="text-center font-bold whitespace-nowrap">
						<span className="text-xl occurrence-value">
							{occurrence?.sumAttended || 0}
						</span>
					</p>
				</div>
			</div>
		</div>
	);
};

export default Occurrence;
